import { render, staticRenderFns } from "./patch-textarea.vue?vue&type=template&id=6b872a22&scoped=true"
import script from "./patch-textarea.vue?vue&type=script&lang=ts"
export * from "./patch-textarea.vue?vue&type=script&lang=ts"
import style0 from "./patch-textarea.vue?vue&type=style&index=0&id=6b872a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b872a22",
  null
  
)

export default component.exports